import PropTypes from 'prop-types'
import cn from '../modules/cn'
import propTypeDeprecation from '../modules/propTypeDeprecation'

const spacing = {
  0: 'space-x-0',
  0.5: 'space-x-0.5',
  1: 'space-x-1',
  1.5: 'space-x-1.5',
  2: 'space-x-2',
  2.5: 'space-x-2.5',
  3: 'space-x-3',
  3.5: 'space-x-3.5',
  4: 'space-x-4',
}

function WithAddon({
  leadingAddon,
  trailingAddon,
  fontSize,
  spaceX,
  fullWidth,
  children,
  className,
  wrapperClassName,
  leadingAddonClassName,
  trailingAddonClassName,
  ...props
}) {
  return (
    <div className={cn('flex flex-grow', spaceX && spacing[spaceX], wrapperClassName)}>
      {leadingAddon && (
        <div
          className={cn('flex items-center justify-center', fontSize && `text-[${fontSize}]`, leadingAddonClassName)}
        >
          {leadingAddon}
        </div>
      )}
      {children && (
        <div
          className={cn(
            'flex items-center justify-center whitespace-nowrap',
            leadingAddon && 'pl-0.5',
            trailingAddon && 'pr-0.5',
            fullWidth && 'flex-grow',
            className,
          )}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        >
          {children}
        </div>
      )}
      {trailingAddon && (
        <div
          className={cn('flex items-center justify-center', fontSize && `text-[${fontSize}]`, trailingAddonClassName)}
        >
          {trailingAddon}
        </div>
      )}
    </div>
  )
}

WithAddon.propTypes = {
  leadingAddon: PropTypes.node,
  trailingAddon: PropTypes.node,
  fontSize: propTypeDeprecation(
    PropTypes.string,
    'Use leadingAddonClassName and/or trailingAddonClassName instead',
  ),
  spaceX: propTypeDeprecation(
    PropTypes.oneOf(Object.keys(spacing).map((space) => Number(space))),
    'Add space-x-[int] to wrapperClassName instead.',
  ),
  fullWidth: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.string, PropTypes.number]),
  className: cn.propType,
  wrapperClassName: cn.propType,
  leadingAddonClassName: cn.propType,
  trailingAddonClassName: cn.propType,
}

WithAddon.defaultProps = {
  leadingAddon: null,
  trailingAddon: null,
  fontSize: null,
  spaceX: null,
  fullWidth: false,
  children: null,
  className: null,
  wrapperClassName: null,
  leadingAddonClassName: null,
  trailingAddonClassName: null,
}

export default WithAddon
